"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopupCTA = exports.MobilePopupCTA = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_popup_1 = require("@snapchat/web-popup");
require("./z-indexes.css");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const banner_img_1 = require("./banner-img");
const CTAPopupContext = (0, react_1.createContext)({
    isOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openPopup: () => { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closePopup: () => { },
});
const PopupCTAModal = (0, react_1.lazy)(async () => Promise.resolve().then(() => __importStar(require("./PopupCTAModal"))));
/**
 * add this to the top of your page's component tree
 */
function MobilePopupCTA({ children }) {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const popupPropsRef = (0, react_1.useRef)();
    const openPopup = (0, react_1.useCallback)((withProps) => {
        popupPropsRef.current = withProps;
        setIsOpen(true);
    }, []);
    const closePopup = (0, react_1.useCallback)(() => {
        setIsOpen(false);
    }, []);
    const contextVal = (0, react_1.useMemo)(() => ({
        isOpen,
        closePopup,
        openPopup,
    }), [isOpen, closePopup, openPopup]);
    (0, react_1.useEffect)(() => {
        // Prefetching the Banner Image
        const img = new Image();
        img.src = banner_img_1.BANNER_IMG_URL;
    }, []);
    return ((0, jsx_runtime_1.jsx)(CTAPopupContext.Provider, { value: contextVal, children: (0, jsx_runtime_1.jsxs)(web_popup_1.PopupProvider, { children: [children, isOpen && ((0, jsx_runtime_1.jsx)(web_popup_1.Popup, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: "", children: (0, jsx_runtime_1.jsx)(PopupCTAModal, { ...(popupPropsRef.current ?? {
                                pageType: web_blizzard_reporting_1.PageType.UNSET,
                                ctaLink: "",
                            }), closePopup: closePopup }) }) }))] }) }));
}
exports.MobilePopupCTA = MobilePopupCTA;
/**
 * Custom Hook which can be used to turn on and off the CTA Popup
 */
function usePopupCTA() {
    return (0, react_1.useContext)(CTAPopupContext);
}
exports.usePopupCTA = usePopupCTA;
//# sourceMappingURL=index.js.map